'use strict';

var config = require('./config');
const transition = require('transition-to-from-auto');
const _ = require('underscore');
const $ = require('jquery');

const globalisation = require('../utilities/globalisation');
import {globalAjaxErrorHandler} from '../utilities/errorHandling';

let customerIpData = null;

const utilities = {
  /**
   * Check a value to see if it is an integer.
   *
   * @param {number|string} num - The value to check
   * @returns {boolean}
   */
  isInteger: function(num) {
    return /^\d+$/.test(num);
  },

  /**
   * Turn a value in to an integer.
   *
   * @param {(string|number)} quantity
   * @returns {number}
   */
  parseQuantity: function(quantity) {
    if (_.isString(quantity)) {
      // Turn locale string in to an integer
      return Math.floor(globalisation.parseNumber(quantity));
    } else {
      return parseInt(quantity, 10);
    }
  },

  /**
   * Take an object and turn it in to a URL string.
   *
   * Note: This does not deal with nested objects
   *
   * @param {object} obj
   * @returns {string}
   */
  serialize: function(obj) {
    var str = decodeURIComponent($.param(obj));

    // Force a ? at the start of simple urls do not include anything other than params
    if (str.indexOf('=') !== -1 && str.indexOf('?') === -1) {
      str = '?' + str;
    }
    return str;
  },

  /**
   * Take a URL string and turn it in to an object.
   *
   * @param {string} str
   * @returns {object}
   */
  deserialize: function(str) {
    if (!str) {
      return false;
    }

    var params = str.replace(/^\s+/, '').replace(/^\?/, '').replace(/\+/g, '%20').replace(/\%\%/g, '%25%').split('&');

    return _.map(params, function(n) {
      var k;

      n = decodeURIComponent(n).split('=');

      // If a filter is found while deserializing, jiggery poke the result.
      if (n[0] === 'filters') {
        var f = n[1].replace(/(^\ )/, '').split(';'),
          filterObject = {};

        for (var i = 0; i < f.length; i++) {
          k = f[i].split(':');

          if (k[2] === 'Equal' || k[2] === 'GreaterThanOrEqual' || k[2] === 'LessThanOrEqual' || k[2] === 'GreaterThan' || k[2] === 'LessThan') {
            var fromToArray = [];
            fromToArray.push(k[1] + ':' + k[2]);
            if (k[4]) fromToArray.push(k[3] + ':' + k[4]);
            filterObject[k[0]] = fromToArray;
          } else if (k[1]) {
            filterObject[k[0]] = k[1].split('|');
          }
        }

        n[1] = filterObject;
      }

      if (typeof this[n[0]] === 'undefined') {
        // Single new item
        this[n[0]] = n[1];
      } else if (typeof this[n[0]] === 'object') {
        // Append to array
        this[n[0]].push(n[1]);
      } else {
        // Turn single item in to array
        this[n[0]] = [this[n[0]], n[1]];
      }

      return this;

    }, {})[0];
  },

  parseFilterString: function(dataObject) {

    var newFilterArray = [],
      clonedDataObject = $.extend(true, {}, dataObject);

    _.each(clonedDataObject.filters, function(item, key) {
      if (item[0] !== '') {
        var a = [];

        //test for a less than or greater than filter, will apply to sliders and from/to
        if (clonedDataObject.filters[key][0] && (clonedDataObject.filters[key][0].split(':')[1] === 'gte' || clonedDataObject.filters[key][0].split(':')[1] === 'lte')) {
          clonedDataObject.filters[key] = clonedDataObject.filters[key].join(':');
        } else {
          //It's just a normal filter
          clonedDataObject.filters[key] = clonedDataObject.filters[key].join('|');
        }
        a.push(key, clonedDataObject.filters[key]);
        a.join(':');
        newFilterArray.push(a.join(':'));
      }
    });

    if (newFilterArray.length > 0) {
      clonedDataObject.filters = newFilterArray.join(';') + ';';
    } else {
      clonedDataObject.filters = newFilterArray.join(';');
    }

    if (!clonedDataObject.filters) {
      delete clonedDataObject.filters;
    }

    return clonedDataObject;

  },

  /**
   * Rounds a value to the nearest 2 decimal places, 0.005 rounds up and 0.004 rounds down.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round}
   * @param {number|string} value
   * @returns {string}
   */
  currencyRound: function(value) {
    var exp = -2; // 2 decimal places
    value = +value;

    // If the value is not a number or the exp is not an integer...
    if (isNaN(value)) {
      return NaN;
    }

    // BKT-855 - Round up if less than 0.01 to prevent 0 values
    if (value > 0 && value < 0.01) {
      return '0.01';
    }

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));

    // Shift back
    value = value.toString().split('e');
    return Number(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)).toFixed(2);
  },

  /**
   * Prints a price with commas as thousands separators
   *
   * @param {number|string} value
   * @returns {string}
   */
  priceWithCommas: function(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  /**
   * Apply the current exchange rate to a value (from config.locale.exchangeRate).
   *
   * @param {number|string} value
   * @returns {number}
   */
  applyExchangeRate: function(value) {
    value = Number(value);
    if (typeof value !== 'number') {
      console.error('applyExchangeRate only accepts numbers, got', value);
    }

    return value * config.locale.exchangeRate;
  },

  /**
   * Calculate the price based on the price bands.
   *
   * @param {number} quantity
   * @param {PriceBand[]} priceBands
   * @returns {number}
   */
  getPriceTierIndex: function(quantity, priceBands) {
    if (!utilities.isInteger(quantity)) {
      return -1;
    }

    return _.findLastIndex(priceBands, function(band) {
      return (quantity >= band.fromQuantity);
    });
  },

  /**
   * Calculate the price for a given quantity.
   *
   * @param {number} quantity
   * @param {PriceBand[]} priceBands
   * @returns {string}
   */
  calculateQuantityPrice: function(quantity, priceBands) {
    // Work out the price band to use based on the quantity
    var band = utilities.getPriceTierIndex(quantity, priceBands);

    if (band === -1) {
      return NaN;
    }

    return utilities.currencyRound(priceBands[band].price * quantity);
  },

  calculateQuantityOriginalPrice: function(quantity, priceBands) {
    // Work out the price band to use based on the quantity
    var band = utilities.getPriceTierIndex(quantity, priceBands);

    if (band === -1) {
      return NaN;
    }

    return utilities.currencyRound(priceBands[band].originalPrice * quantity);
  },

  /**
   * Calculate the price of a product given a quantity.
   *
   * Returns NaN if a non-valid quantity is given.
   *
   * @param {number} quantity
   * @param {BuyingOption} model
   * @returns {string}
   */
  calculateLineItemPrice: function(quantity, model) {
    // Verify the quantity is an integer
    if (!utilities.isInteger(quantity)) {
      return NaN;
    }

    // Verify the increment
    if (quantity % model.orderIncrement !== 0) {
      return NaN;
    }

    // Verify the max quantity
    if (quantity > model.quantity) {
      return NaN;
    }

    // Verify the min quantity
    if (quantity < model.orderMinimumQuantity) {
      return NaN;
    }

    // Calculate the price based on the price bands
    return utilities.calculateQuantityPrice(quantity, model.priceBands);
  },

  /**
   * Return the first HTMLElement from a jQuery collection.
   *
   * @param {jQuery|HTMLElement} element
   * @returns {HTMLElement}
   */
  returnVanillaElement: function(element) {
    return 'jquery' in element ? element[0] : element;
  },

  /**
   * Get the vendor prefixed transitionEnd event name.
   *
   * @returns {string}
   */
  getTransitionEndName: function() {
    if (!this.transitionEndName) {
      var transitionEndNames = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd',
        msTransition: 'MSTransitionEnd',
        transition: 'transitionend'
      };

      this.transitionEndName = transitionEndNames[Modernizr.prefixed('transition')];
    }

    return this.transitionEndName;
  },

  /**
   * Get the vendor prefixed animationEnd event name.
   *
   * @returns {string}
   */
  getAnimationEndName: function() {
    if (!this.animationEndName) {
      var animationEndNames = {
        WebkitAnimation: 'webkitAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        OAnimation: 'oanimationend',
        msAnimation: 'MSAnimationEnd',
        transition: 'animationend',
        animation: 'animationend'
      };

      this.animationEndName = animationEndNames[Modernizr.prefixed('animation')];
    }

    return this.animationEndName;
  },

  staggerElementAnimation: function($elems, isOut) {
    var timeout;
    if (isOut) {
      clearTimeout(timeout);
      _.each($elems, function(elem) {
        $(elem).removeClass(config.classes.isVisible);
      });
    } else {
      $elems.each(function(index) {
        var $this = $(this);
        timeout = setTimeout(function() {
          $this.addClass(config.classes.isVisible);
        }, index * 20);
      });
    }
  },

  animateToAuto: function($el, property) {
    var el = $el.get(0);

    transition({
      element: el,
      val: 'auto',
      prop: property
    });

  },

  animateFromAuto: function($el, property) {
    var el = $el.get(0);

    $el.one(utilities.getTransitionEndName(), function() {
      $el.attr('style', '');
    });

    transition({
      element: el,
      val: 0,
      prop: property
    });

  },

  /**
   * Check to see if an element is partially within the viewport.
   *
   * @param {HTMLElement} element
   * @param {ClientRect} [rect]
   * @param {{height: number, width: number}} [viewport]
   * @returns {boolean}
   */
  isElementPartiallyInViewport: function(element, rect, viewport) {
    rect = rect || element.getBoundingClientRect();
    viewport = viewport || this.getViewportDimensions();

    // We have no size - e.g. are hidden
    if (rect.width === 0 && rect.height === 0) {
      return false;
    }

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= viewport.height &&
      rect.left <= viewport.width
    );
  },

  /**
   * Check to see if an element is completely within the viewport.
   *
   * @param {HTMLElement} element
   * @param {ClientRect} [rect]
   * @param {{height: number, width: number}} [viewport]
   * @param {boolean} [ignoreHorizontal = false]
   * @returns {boolean}
   */
  isElementCompletelyInViewport: function(element, rect, viewport, ignoreHorizontal = false) {
    rect = rect || element.getBoundingClientRect();
    viewport = viewport || this.getViewportDimensions();

    // We have no size - e.g. are hidden
    if (rect.width === 0 && rect.height === 0) {
      return false;
    }

    //element hidden but still present in document
    let elementHiddenByOpacity = this.doesElementHaveParentWithCssProperty(element, 'opacity', '0');
    if (elementHiddenByOpacity) {
      return false;
    }

    let isInVertical = rect.top >= 0 && rect.bottom <= viewport.height;
    let isInHorizontal = ignoreHorizontal ? true : rect.left >= 0 && rect.right <= viewport.width;

    return isInVertical && isInHorizontal;

  },

  doesElementHaveParentWithCssProperty(element, property, value) {
    return $(element)
      .parents()
      .filter(function() {
        return $(this).css(property) === value;
      }).length > 0;
  },

  /**
   * Get the viewport dimensions.
   *
   * @returns {{height: number, width: number}}
   */
  getViewportDimensions: function() {
    var viewport = document.documentElement;
    return {
      height: viewport.clientHeight,
      width: viewport.clientWidth
    };
  },

  ajaxErrorHandler: globalAjaxErrorHandler,

  jsonp: function(url, options) {
    var deferred = $.Deferred();

    options.url = url;
    options.callbackParameter = options.callbackParameter || 'callback';
    options.timeout = options.timeout || 10000;

    options.success = function(json, textStatus, $xhr) {
      deferred.resolve(json, textStatus, $xhr);
    };

    options.error = function($xhr, textStatus) {
      deferred.reject($xhr, textStatus);
      // Trigger global error handler
      utilities.ajaxErrorHandler(null, $xhr);
    };

    $.jsonp(options);

    return deferred.promise();
  },

  localStorageLoad: function(key, fallbackObj) {
    if (!Modernizr.localstorage) {
      return fallbackObj;
    }
    let storageValue = window.localStorage.getItem(key);
    try {
      return JSON.parse(storageValue);
    } catch (e) {
      return storageValue;
    }
  },

  localStorageSave: function(key, data, onFail) {
    if (!Modernizr.localstorage) {
      if (typeof onFail === 'function') {
        onFail(data);
      }
      return false;
    }

    window.localStorage.setItem(key, JSON.stringify(data));
    return true;
  },

  sessionStorageLoad: function(key, fallbackObj) {
    if (!Modernizr.sessionstorage) {
      return fallbackObj;
    }
    let sessionValue = window.sessionStorage.getItem(key);
    try {
      return JSON.parse(sessionValue);
    } catch (e) {
      return sessionValue;
    }
  },

  sessionStorageSave: function(key, data, onFail) {
    if (!Modernizr.sessionstorage) {
      if (typeof onFail === 'function') {
        onFail(data);
      }
      return false;
    }
    window.sessionStorage.setItem(key, JSON.stringify(data));
    return true;
  },

  sessionStorageRemove: function(key) {
    if (Modernizr.sessionstorage) {
      window.sessionStorage.removeItem(key);
    }
    return true;
  },

  /**
   * Split an array in to multiple chunks of a given size.
   *
   * @param {Array} data
   * @param {number} chunkSize
   * @returns {Array[]}
   */
  chunkArray: function(data, chunkSize) {
    return _.chain(data).groupBy(function(val, index) {
      return Math.floor(index / chunkSize);
    }).toArray().value();
  },

  /**
   * The form that is expected is a serialized array form from jquery.
   * Send in a form like so utilities.convertJqueryFormToObject(this.$el.find('#form').serializeArray()
   *
   * @param {Array} form
   * @returns {Object}
   */
  convertFormToObject: function(form) {
    let formObject = {};
    _.each(form, (input) => {
      formObject[input.name] = input.value;
    });
    return formObject;
  },

  toHHMMSS: function(string) {
    var fmtime,
      secNum = parseInt(string, 10), // don't forget the second param
      hours = Math.floor(secNum / 3600),
      minutes = Math.floor((secNum - (hours * 3600)) / 60),
      seconds = secNum - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = '0' + hours;
    }
    if ((hours > 0) && (minutes < 10)) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    if (hours === '00') {
      fmtime = minutes + ':' + seconds;
    } else {
      fmtime = hours + ':' + minutes + ':' + seconds;
    }
    return fmtime;
  },

  // Returns URL with query parameters
  queryStringUrl: function(url, params) {
    if (!url) return '';
    if (!params) return url;

    // When there are already query parameters on the URL
    if (url.indexOf('?') === -1) {
      return url + '?' + $.param(params, true);
    }
    return url + '&' + $.param(params, true);
  },

  urlTemplate: function(url, data) {
    var tmpl = _.template(url, {
      interpolate: /\{\{(.+?)\}\}/g
    });
    return data ? tmpl(data) : tmpl;
  },

  isEmailAddress: function(email) {
    var emailRegEx = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,15}|[0-9]{2,3})(\]?)$/;
    return (email.length > 0 && emailRegEx.test(email));
  },

  isValidPassword: function(password) {
    // \u4E00-\u9FCC Chinese-Japanese-Korean Characters
    var passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^*()\-_=+[\]|;:,.<>/?])[A-Za-z\d~!@#$%^*()\-_=+[\]|;:,.<>/?]{12,25}$/;
    return passwordRegEx.test(password);
  },

  /*
    Waits 5 seconds for the passed element to become available.
    Useful for third party scripts etc.
  */
  waitForElement: function(selector, cb) {
    var poll = 0;
    var timer = setInterval(function() {
      if ($(selector).length) {
        clearInterval(timer);
        cb($(selector));
      } else if (poll > 100) {
        clearInterval(timer);
        console.warn('requested selector ' + selector + ' not avaliable');
      } else {
        poll += 1;
      }
    }, 50);

  },

  /**
   * Add custip if needed to a ajax data object (or string)
   *
   * @param {object|string} data
   * @param {string} queryStr
   * @returns {object|string}
   */
  addCustIpToDataObject: function(data, queryStr = document.location.search) {

    // Cache customer IP Data
    if (!customerIpData || typeof customerIpData !== typeof data) {
      var custIp = queryStr.match(/\bcustip=([^&]+)/i);

      if (!custIp) {
        return data;
      }

      if (_.isObject(data)) {
        data.custip = custIp[1];
      }

      if (_.isString(data)) {
        data += '&custip=' + custIp[1];
      }

      customerIpData = data;
    }

    if (data && _.isObject(customerIpData)) {
      _.extend(customerIpData, data);
    }

    return customerIpData;
  },

  /**
   * Add custip if needed to a url
   * @param {string} url to append custIp
   * @param {string} queryStr
   * @returns {object|string}
   */
  addCustIpToUrl: function(url, queryStr = document.location.search) {
    var custIp = queryStr.match(/\bcustip=([^&]+)/i);
    if (!custIp) {
      return url;
    }
    if (_.isString(url)) {
      url += '?custip=' + custIp[1];
    }
    return url;
  },

  getScrollTop() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },

  getScrollTop() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },

  getFirstWordOfString: (phrase) => {
    let spaceIndex = phrase.indexOf(' ');
    return spaceIndex === -1 ? phrase : phrase.substring(0, spaceIndex);
  },

  /**
   * Detect if the user is using a mobile device (phone or tablet)
   *
   * @param {string} [userAgent] - The user agent, defaults to navigator.userAgent
   * @returns {boolean}
   */
  _isMobileOrTabletDevice: function(userAgent = navigator.userAgent) {
    return /iPad|iPhone|iPod|Android|IEMobile|BlackBerry|BB10|Windows Phone|Opera Mini|webOS/gi.test(userAgent);
  },

  /**
   *  escape html for XSS
   *  http://shebang.brandonmintern.com/foolproof-html-escaping-in-javascript/
   */
  escapeHtml: function(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  },

  windowLocationContains: function(str) {
    return window.location.href.indexOf(str) > -1;
  },

  /**
 * check for empty arrowfed
 */
  isEmptyArrowfed: function(arrowfed) {
    if (!arrowfed || arrowfed === '' || arrowfed === 'EMPTY' ||
    arrowfed === 'undefined' || arrowfed === 'null') {
      return true;
    }
    if (!arrowfed.trim()) {
      return true;
    }
    return false;
  }
};

module.exports = utilities;



// WEBPACK FOOTER //
// ./assets/js/utilities.js